import { render, staticRenderFns } from "./SpecialFeats.vue?vue&type=template&id=dc8a4a46&scoped=true"
import script from "./SpecialFeats.vue?vue&type=script&lang=js"
export * from "./SpecialFeats.vue?vue&type=script&lang=js"
import style0 from "./SpecialFeats.vue?vue&type=style&index=0&id=dc8a4a46&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc8a4a46",
  null
  
)

export default component.exports